// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grey-fade-up[data-v-6083f18b]{background-color:rgba(0,0,0,.75)}", ""]);
// Exports
module.exports = exports;
